import { getCdmDataSourcesList } from '@/api';

import React, { Reducer, useCallback, useEffect, useReducer } from 'react';
import { UseCdmDataSource } from './useDataSourceList.enum';
import { reducer } from './useDataSourceList.reducer';
import { INITIAL_STATE } from './useDataSourceList.state';
import { formatForSelect } from './useDataSourceList.utils';

export const useDataSourceList = (publishedOnly: boolean = false) => {
  const [state, dispatch] = useReducer<any, any>(reducer, INITIAL_STATE);

  const getExistDataSources = useCallback(async () => {
    dispatch({
      type: UseCdmDataSource.GET_DATA_SOURCES_REQUEST,
    });
    try {
      const result = await getCdmDataSourcesList({
        pageNumber: 0,
        pageSize: 100000,
      });
      dispatch({
        type: UseCdmDataSource.GET_DATA_SOURCES_REQUEST_DONE,
        payload: formatForSelect(result.content, publishedOnly),
      });
    } catch (e) {
      dispatch({
        type: UseCdmDataSource.GET_DATA_SOURCES_REQUEST_FAILED,
        payload: e,
      });
    }
  }, []);

  useEffect(() => {
    getExistDataSources();
  }, []);

  return {
    ...state,
  };
};
